import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';

(() => {
    'use strict';

    /**
     * @ngdoc controller
     * @name TsoDashboardCtrl
     * @memberof app
     *
     * @description
     * Hello everyone!
     * We love to improve user experience and we’ve made it our devoted job
     * to improve users’ happiness with this carefully designed dashboard.
     * Sincerely yours
     * Mars <3
     *
     * @author flzemke.btc
     */
    angular.module('app').controller('TsoDashboardCtrl', TsoDashboardCtrl);

    function TsoDashboardCtrl(authService, $location, tsoNotificationResource) {
        var vm = this;
        vm.loggedInUser = null;
        vm.tsoNotifications = 'test';
        vm.loadingError = false;
        vm.loadingData = true;
        vm.notificationsHaveBeenAvailableInitially = false;
        vm.queryLastXDays = 30;
        vm.calculatedSinceDate = moment()
            .subtract(vm.queryLastXDays, 'days')
            .toDate();

        tsoNotificationResource
            .queryUnprocessedSince(
                { sinceDate: vm.calculatedSinceDate },
                (res: TsoNotificationDto[]) => {
                    vm.tsoNotifications = res;
                    vm.loadingError = false;
                    vm.loadingData = false;
                },
                () => {
                    vm.loadingError = true;
                    vm.loadingData = false;
                }
            )
            .$promise.finally(() => {
                vm.notificationsHaveBeenAvailableInitially =
                    this.tsoNotifications.length > 0;
            });

        authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                if (!!loginResult) {
                    vm.loggedInUser = loginResult;
                    if (vm.loggedInUser.role == 'TSO_USER') {
                        // $location.url('/settings');
                    }
                }
            }
        );
    }
})();
